import { Component, Inject } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Subscription, } from "rxjs";
import { StoreService } from "src/app/shared/services/store.service";

@Component({
  selector: 'web-nb-redirect',
  templateUrl: './nb-redirect.component.html',
  styleUrls: ['./nb-redirect.component.scss']
})
export class NbRedirectComponent {
  constructor(
    private dialogRef: MatDialogRef<NbRedirectComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private storeService: StoreService,
    private router: Router,
  ) { }

  retryWithNb() {
    this.dialogRef.close({ data: false });
    this.router.navigate(['/loan/net-banking/bank-account-verify'])
  }

  proceedWithNb() {
    const houseBankId = this.data?.info?.other?.data?.redirectScreenData?.houseBankId.toString() || "";
    const encrypted = this.storeService.encryptParam(houseBankId);
    this.router.navigate([`/loan/net-banking/${encrypted}`]);
    this.dialogRef.close({ data: false });

  }
}
